import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Qualifying_invitation } from '../models/qualifying_invitation';
import { Signature } from '../models/signature';

import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class QualifyingInvitationService {

  constructor(private http: HttpClient) { }

	getList(): Promise<Qualifying_invitation[]> {
		return this.getListWithRest("");
	}

  private getListWithRest(rest_url: string) : Promise<Qualifying_invitation[]> {
  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'qualifying_invitations/' + rest_url).subscribe((response:any) => {
			if(response.type == 'qualifying_invitations' && response.data){
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error_response => {
	      		if(error_response instanceof HttpErrorResponse){
	      			reject(error_response.error);
	      		}
	      		reject(error_response);
			});
	});
  }

  declineInvitation(invitation: Qualifying_invitation, signature: Signature): Promise<boolean> {
  	let put_data = {
          data: {type: 'decline_invitation_request',
          attributes: { invitation_id: invitation.id, signature: signature }
          }
        };

      return new Promise((resolve, reject) => {

      return this.http.put(AppSettings.API_ENDPOINT + 'qualifying_invitations',
          put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
               if(response.data && response.type=='decline_invitation_response') {
                 resolve(response.data);
                 }  else {
                   reject(response);
                 }

          }, error => {
            if(error instanceof HttpErrorResponse){
                reject(error.error);
              } else {
                reject(error);
              }
          });
      });

  }

  convertEntry(invitation_id: string, user_id: string): Promise<boolean> {
      let post_data = {
          data: {
            type: 'entry_conversion_request',
            attributes: { invitation_id: invitation_id, user_id: user_id }
            }
        };

    return new Promise((resolve, reject) => {
      return this.http.post(AppSettings.API_ENDPOINT + 'qualifying_invitations',
        post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
          if(response.data && response.type=='entry_conversion_response') {
               resolve(response.data);
               }  else {
                 reject(response);
               }

        }, error => {
          if(error instanceof HttpErrorResponse){
            reject(error.error);
          } else {
            reject(error);
          }
        });
    });
  }

}
